export default "__VITE_ASSET__Djv8$QvY__"